export const RecipientSourceEnum = Object.freeze({
    CONTACTS: "CONTACTS",
    NEW_RECIPIENT: "NEW_RECIPIENT",
    PREVIOUS_RECIPIENTS: "PREVIOUS_RECIPIENTS",
});
